import { Injectable, Inject, Optional } from '@angular/core';
import { RESPONSE } from '../../express.token';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectHandlerService {
  private pendingRedirect: { status: number; url: string } | null = null;

  constructor(
    @Optional() @Inject(RESPONSE) private response: any,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  setPendingRedirect(status: number, url: string): void {
    this.pendingRedirect = { status, url };
    
    // Try immediate redirect if we have the response object
    if (this.response && !isPlatformBrowser(this.platformId)) {
      this.executePendingRedirect();
    }
  }

  executePendingRedirect(): boolean {
    if (!this.pendingRedirect) {
      return false;
    }

    if (!isPlatformBrowser(this.platformId) && this.response) {
      try {
        this.response.redirect(this.pendingRedirect.status, this.pendingRedirect.url);
        this.pendingRedirect = null;
        return true;
      } catch (error) {
      }
    }

    return false;
  }

  getPendingRedirect(): { status: number; url: string } | null {
    return this.pendingRedirect;
  }

  clearPendingRedirect(): void {
    this.pendingRedirect = null;
  }
} 